import React from 'react';

import { mq } from '@helpers/breakpoints';
import { Box, Flex, Heading, Text } from '@rebass/emotion';
import { GatsbyImage } from '@templates/default/components';
import Colors from '@theme/colors';

const Header = ({
  location,
  topText,
  phone,
  email,
  disableHeader,
}: {
  location?: any;
  topText?: string;
  phone?: string;
  email?: string;
  disableHeader?: string;
}) => {
  const isRLS = location ? location.pathname.includes('neurology/restless-legs-syndrome-study') : false;
  const isRocheAlectinibSignUpPage =
    location && location.href ? location.href.includes('oncology/ALKPositivecancerstudy/sign-up') : false;
  const isDcriTlpSignup =
    location && location.href ? location.href.includes('participants/rheumatology/teen-lupus-study/index.tsx') : false;
  const isRocheAlectinib =
    location && !isRocheAlectinibSignUpPage ? location.pathname.includes('oncology/ALKPositivecancerstudy') : false;

  const isDCRITlp =
    location && !isDcriTlpSignup ? location.pathname.includes('participants/rheumatology/teen-lupus-study') : false;
  const rowDirection = isRLS ? 'row-reverse' : 'row';
  const logo = isRLS || isDCRITlp ? 's37_rlogo_black.png' : 's37_green_logo.png';

  if (!location || typeof location === 'undefined' || disableHeader) {
    return <div />;
  }

  if (isDCRITlp) {
    return (
      <Box bg="#e9e9e9" minHeight={80} pt={3} pb={3} width={'auto'}>
        <Box
          width={['auto', 'auto', 'auto', 'auto']}
          mt={[0, 1]}
          borderRadius={8}
          className="section-wrapper"
          pl={[20, 50, 128, 20]}
        >
          <a href="https://www.science37.com">
            <GatsbyImage
              imgsrc={logo}
              mt={10}
              css={mq({
                width: ['140px'],
              })}
            />
          </a>
        </Box>
      </Box>
    );
  }

  if (isRocheAlectinib || isRocheAlectinibSignUpPage) {
    return (
      <Box bg="#e9e9e9" minHeight={80} pt={3} pb={3}>
        <Box mt={[0, 1]} mx="auto" width={['95%', '95%', '95%', '80%']}>
          <Box px={'6px'}>
            <a href="/">
              <GatsbyImage
                imgsrc={logo}
                mt={10}
                css={mq({
                  width: ['140px'],
                })}
              />
            </a>
          </Box>
        </Box>
      </Box>
    );
  }

  if (isRLS) {
    return (
      <Flex
        css={mq({
          position: 'fixed',
          maxWidth: '1900px',
          width: '100%',
          top: '0',
          zIndex: '100',
        })}
        px={[2, 4, 5]}
        py={[2]}
        alignItems="center"
        justifyContent="space-between"
        backgroundColor={`${Colors.neutral0}`}
      >
        <Box width={['40%', '50%', 1 / 4]}>
          <Heading css={mq({ marginBottom: '5px' })} fontSize={[1, 2, 3]}>
            {topText}
          </Heading>
          <Text
            fontSize={[1, 2]}
            css={mq({
              display: ['inline-block'],
              marginRight: '12px',
              color: `${Colors.science37}`,
              fontWeight: '700',
            })}
          >
            {phone}
          </Text>
          <Text
            fontSize={[1, 2]}
            css={mq({
              display: ['inline-block'],
              color: `${Colors.science37}`,
              fontWeight: '700',
            })}
          >
            {email}
          </Text>
        </Box>
        <Box width={[0.4, 1 / 4, 1 / 5]}>
          <a href="https://www.science37.com">
            <GatsbyImage imgsrc={logo} />
          </a>
        </Box>
      </Flex>
    );
  }

  if (location) {
    return (
      <Flex px={3} py={1} alignItems="center" flexDirection={rowDirection}>
        <Box width={[0.4, 1 / 4, 1 / 5]} mt={[0, 2]} mr={[0, 4]} borderRadius={8}>
          <a href="https://www.science37.com">
            <GatsbyImage imgsrc={logo} />
          </a>
        </Box>
        <Box mx="auto" />
      </Flex>
    );
  }

  return <div />;
};

export default Header;
